import React, { Component} from 'react'
import Navbar from './NavBar';
import "./registration.css"
import emailjs from '@emailjs/browser';


// const form = useRef();
// const sendEmail = (e) => {
//   console.log("trigerred");
//   e.preventDefault();
 


//   emailjs.sendForm('service_q2ak5gn', 'template_hogc9ra', form.current, 'PoLyKRhMxGb0hOGGf')
//     .then((result) => {
//         console.log(result.text);
//         alert("We've recieved your message.")
//         form.current.reset();
//     }, (error) => {
//         console.log(error.text);
//         alert("Sorry there was some error.")
//     });
// };

export default class RegisterForm extends Component {
  
 
    constructor() {
        super();
        this.state = {
          fields: {user_name:'',user_email:'',user_phone_number:'',message:''},
          errors: {}
        }
        this.myRef = React.createRef();
  
        this.handleChange = this.handleChange.bind(this);
        this.submituserRegistrationForm = this.submituserRegistrationForm.bind(this);
  
      };
  
      handleChange(e) {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
          fields
        });
      
  
      }
  
      submituserRegistrationForm(e) {
        console.log(this.validateForm());
        
        e.preventDefault();
        if (this.validateForm()) {
            console.log(this.state);
             let fields = {};
             fields["user_name"] = "";
             fields["user_email"] = "";
             fields["user_phone_number"] = "";
             fields["message"] = "";
            this.setState({fields:fields});
            console.log(this.state);
            emailjs.sendForm('service_q2ak5gn', 'template_hogc9ra', this.myRef.current, 'PoLyKRhMxGb0hOGGf')
            .then((result) => {
                console.log(result.text);
                alert("We've recieved your message.")
                this.myRef.current.reset();
            }, (error) => {
                console.log(error.text);
                alert("Sorry there was some error.")
            });
        }
  
      }
  
      validateForm() {
  
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
  
        if (!fields["user_name"]) {
          formIsValid = false;
          errors["user_name"] = "*Please enter your username.";
        }
  
        if (typeof fields["user_name"] !== "undefined") {
          if (!fields["user_name"].match(/^[a-zA-Z ]*$/)) {
            formIsValid = false;
            errors["user_name"] = "*Please enter alphabet characters only.";
          }
        }
  
        if (!fields["user_email"]) {
          formIsValid = false;
          errors["user_email"] = "*Please enter your email-ID.";
        }
  
        if (typeof fields["user_email"] !== "undefined") {
          //regular expression for email validation
          var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
          if (!pattern.test(fields["user_email"])) {
            formIsValid = false;
            errors["user_email"] = "*Please enter valid email-ID.";
          }
        }
  
        if (!fields["user_phone_number"]) {
          formIsValid = false;
          errors["user_phone_number"] = "*Please enter your mobile no.";
        }
  
        if (typeof fields["user_phone_number"] !== "undefined") {
          if (!fields["user_phone_number"].match(/^[0-9]{10}$/)) {
            formIsValid = false;
            errors["user_phone_number"] = "*Please enter valid mobile no.";
          }
        }
  
        if (!fields["message"]) {
          formIsValid = false;
          errors["message"] = "*Please enter your message.";
        }
  
        this.setState({
          errors: errors
        });
        return formIsValid;
  
  
      }

       

  
  
  
    render() {
      return (
        <>
        <Navbar/>
      <div id="main-registration-container">
       <div id="register">
          <h3 >Contact Us page</h3>
          <form method="post"  name="userRegistrationForm"  onSubmit= {this.submituserRegistrationForm}  ref={this.myRef}>
          <label>Name</label>
          <input type="text" name="user_name" value={this.state.fields.user_name} onChange={this.handleChange} />
          <div className="errorMsg">{this.state.errors.user_name}</div>
          <label>Email ID:</label>
          <input type="text" name="user_email" value={this.state.fields.user_email} onChange={this.handleChange}  />
          <div className="errorMsg">{this.state.errors.user_email}</div>
          <label>Mobile No:</label>
          <input type="text" name="user_phone_number" value={this.state.fields.user_phone_number} onChange={this.handleChange}   />
          <div className="errorMsg">{this.state.errors.user_phone_number}</div>
          <label>message</label>
        <textarea rows={5}  type="message" name="message" value={this.state.fields.message} onChange={this.handleChange} />
          <div className="errorMsg">{this.state.errors.message}</div>
          <input type="submit" className="button"  value="Send"/>
          </form>
      </div>
  </div>
  </>
  
        );
    }
  
  
  }
